import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Eject = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Eject" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M20 17C21.6569 17 23 18.3431 23 20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20C1 18.3431 2.34315 17 4 17H20ZM4 19C3.44772 19 3 19.4477 3 20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19H4Z" fill="#000" /><path fillRule="evenodd" clipRule="evenodd" d="M12 1C12.3148 1 12.611 1.14858 12.7998 1.40039L21.7998 13.4004C22.027 13.7034 22.0639 14.1085 21.8945 14.4473C21.7251 14.786 21.3788 15 21 15H3C2.62123 15 2.27486 14.786 2.10547 14.4473C1.93611 14.1085 1.97304 13.7034 2.2002 13.4004L11.2002 1.40039L11.2754 1.31055C11.463 1.11339 11.7245 1 12 1ZM4.99902 13H19.001L12 3.66602L4.99902 13Z" fill="#000" />
  </StyledIcon>
));

Eject.displayName = 'Eject';

export { Eject };
